import * as React from "react";
import * as ReactDOM from "react-dom";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import diyLightTheme = require("diy/material-ui/diyLightTheme");
import IconButton from "material-ui/IconButton";
import ActionInfo from 'material-ui/svg-icons/action/info';
import Dialog from "diy/moments-to-celebrate/components/Dialog";
//import $ = require('jquery');

import l10n from "diy/util/l10n";

//import websiteData = require("diy/util/websiteData");

export default class ShowroomDesignInfo {

    private designInfoContainer: HTMLElement;
    private designInfoBoxContainer: HTMLElement;
    private topLevelContainer: HTMLElement;

    destroy() {
        ReactDOM.unmountComponentAtNode(this.designInfoContainer);
    };

    show(container?: HTMLElement) {
        this.topLevelContainer = container || document.body;

        this.designInfoContainer = document.getElementById('designLayoutInfo');
        if (this.designInfoContainer === null) {
            this.designInfoContainer = document.createElement('div');
            this.designInfoContainer.id = 'designLayoutInfo';

            this.topLevelContainer.appendChild(this.designInfoContainer);

            let styles = this.getStyles();

            const DesignInfoPlaceholder = () => (
                <MuiThemeProvider muiTheme={diyLightTheme}>
                    <IconButton
                        onTouchTap={() => {this.showDesignInfoBox();}}
                        iconStyle={styles.iconStyle}
                        style={styles.button}
                    >
                        <ActionInfo color="#FFFFFF" />
                    </IconButton>
                </MuiThemeProvider>
            );

            ReactDOM.render(
                <DesignInfoPlaceholder />,
                this.designInfoContainer
            );
        }
    };

    hide(): boolean {
        if (this.designInfoContainer) {
            ReactDOM.unmountComponentAtNode(this.designInfoContainer);
            this.designInfoContainer.parentElement.removeChild(this.designInfoContainer);
            this.designInfoContainer = null;
        }
        return true;
    };

    showDesignInfoBox() {
        this.designInfoBoxContainer = document.createElement('div');
        this.designInfoBoxContainer.id = 'designLayoutInfoBox';

        this.topLevelContainer.appendChild(this.designInfoBoxContainer);

        const DesignInfoBoxPlaceholder = () => (
            <MuiThemeProvider muiTheme={diyLightTheme}>
                <Dialog
                    title={l10n('showroomDesignInfobox.dialog.title')}
                    secondaryButtonConfig={{
                        primary: true,
                        label: l10n('cancelLabel'),
                        callback: () => this.hideDesignInfoBox()
                    }}
                >
                    <div style={{'padding': '0 25px'}}>
                        <div>{l10n('showroomDesignInfobox.dialog.currentSelectionLabel')}: {diy.website.design.id}</div>
                        <div>{l10n('showroomDesignInfobox.dialog.currentLayoutLabel')}: {diy.website.layout.id}</div>
                        <div style={{'marginTop': "12px"}} >
                            {l10n('showroomDesignInfobox.dialog.disclaimer1')}
                        </div>
                        <div>{l10n('showroomDesignInfobox.dialog.disclaimer2')}</div>
                    </div>
                </Dialog>
            </MuiThemeProvider>
        );

        ReactDOM.render(
            <DesignInfoBoxPlaceholder />,
            this.designInfoBoxContainer
        );
    }

    hideDesignInfoBox(): boolean {
        if (this.designInfoBoxContainer) {
            ReactDOM.unmountComponentAtNode(this.designInfoBoxContainer);
            this.designInfoBoxContainer.parentElement.removeChild(this.designInfoBoxContainer);
            this.designInfoBoxContainer = null;
        }
        return true;
    };

    private getStyles() {
        let styles = {
            'button': {
                position: "absolute",
                top: "0px",
                left: "12px",
                width: "40px",
                height: "40px"
            },
            'iconStyle': {
                width: '16px',
                height: '16px'
            }
        };
        return styles;
    };

}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/showroom/ShowroomDesignInfo.tsx
 **/